const getApiToken = () => {
  const fullToken = localStorage.getItem('admin-token') || '{}'
  const { idToken } = JSON.parse(fullToken) ?? {}
  return idToken
}

export default getApiToken
